export function toPascalCase(input: string, sep: string = ''): string {
  return input
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(sep);
}
